/* 右边全部 */

import React, { useState, useEffect } from 'react'
import NoSSR from 'react-no-ssr'

import Loading from 'Components/loading'

import CarList from './car-list'
import Selected from './selected'
import Conditions from './conditions'
import { ContextStore } from './reducer'

import { IOptionsState, ISortProps, IConditionsProps } from './interface'

interface Props {
  conditions: IConditionsProps[]
  sort: ISortProps[]
}

export default function ConditionsList(props: Props) {
  const { conditions, sort } = props
  return (
    <section>
      <Conditions conditions={conditions} />
      <Selected />
      {/* 车系列表 */}
      <NoSSR onSSR={<Loading />}>
        <CarList sort={sort} />
      </NoSSR>
      <style jsx>
        {`
          section {
            display: inline-block;
            width: 900px;
            margin-left: 16px;
          }
        `}
      </style>
    </section>
  )
}
